import { AssetMetadata } from '@thehubz/shared/model';
import { AccessRole, GlobalRole } from '@thehubz/shared/user-access';
import { SCREEN_SIZE } from '../models';
import { NavigationEntry } from '../models/navigation.interface';
import { PROMPTS } from './prompts.constant';

export interface ScreenSize {
  id: SCREEN_SIZE;
  name: string;
  css: string;
}

export class AppSettings {
  static readonly APP_CONFIG: { navigation: NavigationEntry[] } = {
    navigation: [
      {
        text: $localize`User profile`,
        menuId: 0,
        testId: 'menu-items-li-User-profile',
        visible: false,
        items: [
          {
            key: 'user_profile',
            icon: 'view_compact',
            svgIcon: true,
            text: $localize`User profile`,
            tooltip: $localize`User profile`,
            class: 'icon-menu-special',
            backButton: false,
            backURL: 'dashboard',
            routerLink: 'user/profile',
            items: [],
            visible: false,
          },
        ],
      },
      {
        text: $localize`Dashboard`,
        menuId: 1,
        testId: 'menu-items-li-Dashboard',
        visible: true,
        items: [
          {
            key: 'dashboard',
            icon: 'dashboard_menu_icon',
            svgIcon: true,
            text: $localize`Dashboard`,
            tooltip: $localize`Dashboard`,
            class: 'icon-menu-special',
            backButton: false,
            backURL: '',
            routerLink: 'dashboard',
            items: [],
            visible: false,
          },
        ],
      },
      {
        text: $localize`Collaboration`,
        globalRole: GlobalRole.collab,
        menuId: 1,
        visible: true,
        testId: 'menu-items-li-Collaboration',
        items: [
          {
            key: 'projects',
            globalRole: GlobalRole.project,
            icon: 'projects_menu_icon',
            svgIcon: true,
            text: $localize`Projects`,
            tooltip: 'all_projects',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'projects',
            items: [],
            visible: true,
            testId: 'menu-sub-items-projects',
          },
          {
            key: 'tasks',
            globalRole: GlobalRole.task,
            icon: 'tasks_menu_icon',
            svgIcon: true,
            text: $localize`Tasks`,
            tooltip: 'all_tasks',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'tasks',
            items: [],
            visible: true,
            testId: 'menu-sub-items-tasks',
          },
          {
            key: 'planning',
            globalRole: GlobalRole.planning,
            icon: 'planning_menu_icon',
            svgIcon: true,
            text: $localize`Planning`,
            tooltip: '',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'planning',
            items: [],
            visible: true,
            testId: 'menu-sub-items-planning',
          },
        ],
      },
      {
        text: $localize`Library`,
        menuId: 2,
        globalRole: GlobalRole.library,
        visible: true,
        testId: 'menu-items-li-Library',
        items: [
          {
            key: 'assets',
            icon: 'overview_menu_icon',
            svgIcon: true,
            text: $localize`:assets overview:Overview`,
            tooltip: 'all_assets',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'assets',
            items: [],
            visible: true,
            testId: 'menu-sub-items-overview',
          },
          // hide basket (https://app.clickup.com/t/86bx40t0w)
          /* {
            key: 'assets-basket',
            accessRole: AccessRole.basketAccess,
            icon: 'shopping_cart',
            svgIcon: false,
            text: $localize`Basket`,
            tooltip: 'assets basket',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'assets-basket',
            items: [],
            visible: true,
            testId: 'menu-sub-items-basket',
          }, */
          {
            key: 'collections',
            accessRole: AccessRole.collectionAccess,
            icon: 'perm_media',
            svgIcon: false,
            text: $localize`Collection`,
            tooltip: $localize`Basket Collections`,
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'collections',
            items: [],
            visible: true,
            testId: 'menu-sub-items-collection',
          },
        ],
      },
      {
        text: $localize`Admin`,
        menuId: 3,
        globalRole: GlobalRole.admin,
        visible: true,
        testId: 'menu-items-li-Admin',
        items: [
          {
            key: 'admin_dashboard',
            icon: 'admin_panel_settings',
            svgIcon: true,
            text: $localize`Admin area`,
            tooltip: 'admin area',
            class: 'icon-menu-special',
            routerLink: 'admin',
            items: [],
            visible: false,
            testId: 'menu-sub-items-admin-dashboard',
          },
          {
            key: 'admin_companies',
            icon: 'companies_menu_icon',
            globalRole: GlobalRole.admin_company,
            svgIcon: true,
            text: $localize`Companies`,
            tooltip: 'companies',
            class: '',
            routerLink: 'admin/companies',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-companies',
          },
          {
            key: 'admin_groups',
            icon: 'groups_menu_icon',
            // globalRole: GlobalRole.admin_group,
            svgIcon: true,
            text: $localize`Groups`,
            tooltip: 'groups',
            class: '',
            routerLink: 'admin/groups',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-groups',
          },
          {
            key: 'admin_users',
            icon: 'users_menu_icon',
            globalRole: GlobalRole.admin_users,
            svgIcon: true,
            text: $localize`Users`,
            tooltip: 'users',
            class: '',
            routerLink: 'admin/users',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-users',
          },
          {
            key: 'admin_tags',
            icon: 'tags_menu_icon',
            globalRole: GlobalRole.admin_tags,
            svgIcon: true,
            text: $localize`Tags and Taxonomy`,
            tooltip: AssetMetadata.General.TAGS,
            class: '',
            routerLink: 'admin/tags',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-tags',
          },
          {
            key: 'admin_taxonomy',
            icon: 'taxonomy_menu_icon',
            globalRole: GlobalRole.admin_taxonomy,
            svgIcon: true,
            text: $localize`Taxonomy`,
            tooltip: 'taxonomy',
            class: '',
            routerLink: 'admin/taxonomy',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-tags',
          },
          {
            key: 'teams',
            icon: 'teams_menu_icon',
            globalRole: GlobalRole.admin_teams,
            svgIcon: true,
            text: $localize`Teams`,
            tooltip: '',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'admin/teams',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-teams',
          },
          {
            key: 'workflows',
            icon: 'tasks_menu_icon',
            globalRole: GlobalRole.admin_workflows,
            svgIcon: true,
            text: $localize`Workflows`,
            tooltip: '',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'admin/workflows',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-workflows',
          },
          {
            key: 'tokens',
            icon: 'token',
            globalRole: GlobalRole.admin_api,
            svgIcon: false,
            text: $localize`API Tokens`,
            tooltip: '',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'admin/tokens',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-tokens',
          },
          {
            key: 'info_banners',
            icon: 'maintenance_icon',
            globalRole: GlobalRole.admin_banners,
            svgIcon: true,
            text: $localize`Maintenance/info banner`,
            tooltip: '',
            class: '',
            backButton: false,
            backURL: '',
            routerLink: 'admin/info-banners',
            items: [],
            visible: true,
            testId: 'menu-sub-items-admin-info-banners',
          },
        ],
      },
      {
        text: $localize`Wiki`,
        menuId: 4,
        globalRole: GlobalRole.wiki,
        visible: true,
        testId: 'menu-items-li-Wiki',
        items: [
          {
            key: 'wiki_page',
            icon: 'admin_panel_settings',
            svgIcon: true,
            text: $localize`Wiki`,
            tooltip: 'wiki',
            class: 'icon-menu-special',
            routerLink: 'wiki',
            target: 'blank',
            items: [],
            visible: false,
            testId: 'menu-sub-items-wiki',
          },
        ],
      },
    ],
  };

  static readonly SCREEN_SIZES: ScreenSize[] = [
    {
      id: SCREEN_SIZE.SM,
      name: 'sm',
      css: `block md:hidden lg:hidden xl:hidden`,
    },
    {
      id: SCREEN_SIZE.MD,
      name: 'md',
      css: `hidden md:block lg:hidden xl:hidden`,
    },
    {
      id: SCREEN_SIZE.LG,
      name: 'lg',
      css: `hidden lg:block xl:hidden`,
    },
    {
      id: SCREEN_SIZE.XL,
      name: 'xl',
      css: `hidden xl:block 2xl:hidden`,
    },
    {
      id: SCREEN_SIZE.XXL,
      name: 'xxl',
      css: `hidden 2xl:block xl:hidden`,
    },
  ];

  static readonly ASSET_FILTER_STRING = 'assetFilterString';

  static readonly COLLECTION_FILTER_STRING = 'collectionFilterString';

  static readonly SESSION_STORAGE_KEY = 'itemsSelected';

  static readonly BASKET = 'basket';

  static readonly COLLECTION_BASKET = 'Collection_Basket';

  static readonly WorkFlow_default_config = {
    stepId: '1',
    stepLabel: $localize`Create task`,
    placeholder: $localize`Task creation`,
    possibleNexSteps: [],
    durationInHours: 0,
    stepper: [
      {
        stepperId: '1',
        stepperName: $localize`Task creation`,
        stepperGroupName: 'taskSelection',
        selected: true,
        formFields: [
          {
            formTypeId: '2',
            formFieldName: 'taskType',
            fieldType: 'dropdown',
            fieldLabel: $localize`Select task type`,
            placeholder: '',
            inputType: '',
            mandatory: true,
            validationRegex: '',
            widthClass: 'w-1/2',
            disable: false,
            functionCall: true,
            visible: true,
            options: [],
          },
          {
            formTypeId: '10',
            formFieldName: '',
            fieldType: 'space',
            fieldLabel: '',
            placeholder: '',
            inputType: '',
            overviewHiddenFlag: true,
            hideLabel: false,
            mandatory: false,
            validationRegex: '',
            widthClass: 'w-1/2',
            disable: false,
            visible: true,
          },
          {
            formTypeId: '1',
            formFieldName: 'name',
            fieldType: 'text',
            fieldLabel: $localize`Task name`,
            placeholder: '',
            inputType: 'text',
            mandatory: true,
            validationRegex: '',
            widthClass: 'w-1/2',
            disable: false,
            functionCall: false,
            formGroup: false,
            editable: true,
            visible: true,
          },
          {
            formTypeId: '10',
            formFieldName: '',
            fieldType: 'space',
            fieldLabel: '',
            placeholder: '',
            inputType: '',
            overviewHiddenFlag: true,
            hideLabel: false,
            mandatory: false,
            validationRegex: '',
            widthClass: 'w-1/2',
            disable: false,
            visible: true,
          },
          {
            formTypeId: '13',
            formFieldName: '',
            fieldType: 'buttonLink',
            fieldLabel: $localize`Download workflow`,
            placeholder: '',
            inputType: '',
            overviewHiddenFlag: true,
            validationRegex: '',
            widthClass: 'w-1/5',
            disable: false,
            visible: true,
            callBackFunction: 'downloadSVG()',
            linkType: 'functionCall',
            options: [],
          },
          {
            formTypeId: '13',
            formFieldName: '',
            fieldType: 'buttonLink',
            fieldLabel: $localize`Open workflow`,
            placeholder: '',
            inputType: '',
            overviewHiddenFlag: true,
            validationRegex: '',
            widthClass: 'w-1/5',
            disable: false,
            visible: true,
            linkType: 'href',
            linkUrl: 'workflowCharUrl',
            options: [],
          },
        ],
        actions: [
          {
            actionLabel: PROMPTS.LABELS.NEXT,
            goToStep: 3,
            actionTypePosition: 'right',
            actionType: '',
            actionColor: '',
            actionClass: '',
            url: '',
            icon: 'chevron_right',
            alignIcon: 'right',
            disable: false,
            visible: false,
          },
        ],
      },
    ],
  };

  static readonly Communication_Add_Comment = {
    stepId: '1',
    stepLabel: $localize`Create new comment`,
    placeholder: $localize`Create new comment`,
    possibleNexSteps: [],
    durationInHours: 0,
    stepper: [
      {
        stepperId: '1',
        stepperName: $localize`Create new comment`,
        stepperGroupName: 'addComment',
        assetUploadFlag: true,
        formFields: [
          {
            formTypeId: '4',
            formFieldName: 'commentDescription',
            fieldType: 'textarea',
            fieldLabel: $localize`Comment`,
            placeholder: $localize`Comment`,
            inputType: 'text',
            mandatory: true,
            minlength: 3,
            validationRegex: '',
            widthClass: 'w-full',
            disable: false,
            functionCall: false,
            visible: true,
            value: '',
          },
          {
            formTypeId: '4',
            formFieldName: 'commentData',
            fieldType: 'uploadFiles',
            fieldLabel: $localize`Attachment`,
            placeholder: $localize`Attachment`,
            inputType: '',
            mandatory: false,
            validationRegex: '',
            widthClass: 'w-full',
            disable: false,
            functionCall: false,
            visible: true,
            showAssetLibraryView: false,
          },
        ],
        actions: [
          {
            actionLabel: PROMPTS.LABELS.SUBMIT,
            goToNextStep: 200, // Action for Comment/Reply popup
            actionTypePosition: 'right',
            alignIcon: 'right',
            icon: 'chevron_right',
            actionType: 'submit',
            actionColor: '',
            actionClass: '',
            url: '',
            disable: false,
            visible: false,
          },
        ],
      },
    ],
  };

  static readonly Communication_Delete_Comment = {
    stepId: '48',
    stepLabel: $localize`Delete comment`,
    taskStatus: 'Delete comment',
    placeholder: $localize`:placeholder:Delete comment`,
    milestoneFlag: false,
    durationInHours: 0,
    swimLane: 1,
    stepper: [
      {
        stepperId: '1',
        stepperName: $localize`Delete comment`,
        stepperGroupName: 'blank',
        formFields: [
          {
            formTypeId: '8',
            formFieldName: '',
            fieldType: 'confirmationLabel',
            fieldLabel: $localize`Are you sure you want to delete the comment?`,
            placeholder: '',
            inputType: '',
            mandatory: false,
            validationRegex: '',
            widthClass: 'w-full',
            disable: false,
            assignCall: true,
            formGroup: true,
            visible: true,
            options: [],
          },
        ],
        actions: [
          {
            actionLabel: PROMPTS.LABELS.NO,
            actionTypePosition: 'left',
            actionType: 'close',
            actionColor: '',
            actionClass: '',
            url: '',
            icon: '',
            alignIcon: 'left',
            disable: false,
            visible: false,
          },
          {
            actionLabel: PROMPTS.LABELS.YES,
            goToNextStep: 200, // Action for Comment/Reply popup
            actionTypePosition: 'right',
            actionType: 'submit',
            actionColor: '',
            actionClass: '',
            url: '',
            icon: '',
            alignIcon: 'right',
            disable: false,
            visible: false,
          },
        ],
      },
    ],
    actions: [],
  };

  static readonly REFRESH_TOKEN_CHECK_INTERVAL: number = 3600000; // 1 hr

  static SHOW_EXPIRY_ASSET_IN_DAYS = 30;
}
